import { API, api, apiError } from "@/lib/api";

export async function generateTool(path, body, onProgress) {
  const response = await fetch(`${API}${path}`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("nxt_token")}` }, body: JSON.stringify(body) });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(apiError({ response: { data } }));
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "", result = null;
  while (true) {
    const { done, value } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    const blocks = buffer.split("\n\n");
    buffer = blocks.pop();
    for (const block of blocks) {
      if (!block.startsWith("data: ")) continue;
      const event = JSON.parse(block.slice(6));
      if (event.type === "error") throw new Error(event.detail);
      if (event.type === "complete") result = event.run;
      onProgress(event);
    }
    if (done) break;
  }
  if (!result) throw new Error("The connection ended before your result was ready. Check Saved drafts before retrying.");
  return result;
}

export async function downloadTool(id, kind, format) {
  const { data } = await api.get(`/career-tools/runs/${id}/export`, { params: { format }, responseType: "blob" });
  downloadBlob(data, `nxt-${kind}.${format}`);
}

export function downloadBlob(data, filename) {
  const url = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
